import axios from "axios";

axios.defaults.withCredentials = true;

const isLocalhost = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const client = axios.create({
    baseURL: isLocalhost ? "http://localhost:8080/api" : "/api",
    withCredentials: true,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN'
});

export async function getMe(signal) {
  try {
    const res = await client.get("/me", { signal });
    const data = res.data;
    // Validate shape to avoid treating HTML/redirects or empty objects as an authenticated user
    const isObject = data && typeof data === 'object' && !Array.isArray(data);
    const hasUserFields = isObject && (('id' in data && data.id != null) || (typeof data.username === 'string' && data.username.trim() !== ''));
    if (hasUserFields) {
      return data;
    }
    return null;
  } catch (e) {
    return null;
  }
}

export async function suggestProducts(query, limit = 5, signal) {
  if (!query || !query.trim()) return [];
  try {
    const res = await client.get("/search/suggest", {
      params: { q: query.trim(), limit },
      signal,
    });
    return Array.isArray(res.data) ? res.data : [];
  } catch (e) {
    if (e.name === 'CanceledError') return [];
    return [];
  }
}
